<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.turnover.regularMaleEmployee.$invalid 
      || $v.turnover.nonRegularMaleEmployee.$invalid 
      || $v.turnover.regularFemaleEmployee.$invalid
      || $v.turnover.nonRegularFemaleEmployee.$invalid
      || $v.turnover.regularMaleTurnover.$invalid 
      || $v.turnover.nonRegularMaleTurnover.$invalid
      || $v.turnover.regularFemaleTurnover.$invalid 
      || $v.turnover.nonRegularFemaleTurnover.$invalid
      || $v.turnover.resultMemo.$invalid 
      || $v.turnover.actionMemo.$invalid">

      <div v-if="$v.turnover.regularMaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">労働者数（正社員・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularMaleEmployee.$invalid && !$v.turnover.regularMaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularMaleEmployee.$invalid && $v.turnover.regularMaleEmployee.numeric && !$v.turnover.regularMaleEmployee.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.nonRegularMaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">労働者数（非正規・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularMaleEmployee.$invalid && !$v.turnover.nonRegularMaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularMaleEmployee.$invalid && $v.turnover.nonRegularMaleEmployee.numeric && !$v.turnover.nonRegularMaleEmployee.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.regularFemaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">労働者数（正社員・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularFemaleEmployee.$invalid && !$v.turnover.regularFemaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularFemaleEmployee.$invalid && $v.turnover.regularFemaleEmployee.numeric && !$v.turnover.regularFemaleEmployee.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.nonRegularFemaleEmployee.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">労働者数（非正規・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularFemaleEmployee.$invalid && !$v.turnover.nonRegularFemaleEmployee.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularFemaleEmployee.$invalid && $v.turnover.nonRegularFemaleEmployee.numeric && !$v.turnover.nonRegularFemaleEmployee.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.turnover.regularMaleTurnover.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">離職者数（正社員・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularMaleTurnover.$invalid && !$v.turnover.regularMaleTurnover.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularMaleTurnover.$invalid && $v.turnover.regularMaleTurnover.numeric && !$v.turnover.regularMaleTurnover.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.nonRegularMaleTurnover.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">離職者数（非正規・男性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularMaleTurnover.$invalid && !$v.turnover.nonRegularMaleTurnover.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularMaleTurnover.$invalid && $v.turnover.nonRegularMaleTurnover.numeric && !$v.turnover.nonRegularMaleTurnover.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.regularFemaleTurnover.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">離職者数（正社員・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularFemaleTurnover.$invalid && !$v.turnover.regularFemaleTurnover.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.regularFemaleTurnover.$invalid && $v.turnover.regularFemaleTurnover.numeric && !$v.turnover.regularFemaleTurnover.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>
      <div v-if="$v.turnover.nonRegularFemaleTurnover.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">離職者数（非正規・女性）　　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularFemaleTurnover.$invalid && !$v.turnover.nonRegularFemaleTurnover.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.turnover.nonRegularFemaleTurnover.$invalid && $v.turnover.nonRegularFemaleTurnover.numeric && !$v.turnover.nonRegularFemaleTurnover.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.turnover.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.turnover.resultMemo.$invalid && !$v.turnover.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.turnover.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.turnover.actionMemo.$invalid && !$v.turnover.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">労働者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.regularMaleEmployee" type="text" name="turnover.regularMaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.nonRegularMaleEmployee" type="text" name="turnover.nonRegularMaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.regularFemaleEmployee" type="text" name="turnover.regularFemaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.nonRegularFemaleEmployee" type="text" name="turnover.nonRegularFemaleEmployee" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfRegularEmployee" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularEmployee" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllEmployee" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table03-->
  
      <div class="human-capitalt-data-wrap__space-mini"></div>

      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">離職者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.regularMaleTurnover" type="text" name="turnover.regularMaleTurnover" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.nonRegularMaleTurnover" type="text" name="turnover.nonRegularMaleTurnover" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfMaleTurnover" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.regularFemaleTurnover" type="text" name="turnover.regularFemaleTurnover" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.turnover.$model.nonRegularFemaleTurnover" type="text" name="turnover.nonRegularFemaleTurnover" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfFemaleTurnover" :unit="this.unit1"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfRegularTurnover" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNonRegularTurnover" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAllTurnover" :unit="this.unit1"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table03-->


      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__table03">
        <p class="l-formGroup__label u-mb10">離職率</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>正社員</th>
              <th>非正規社員</th>
              <th>全社</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegularMale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegularMale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.percentageOfAchievementMaleTurnover" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr>
              <th>女性</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegularFemale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegularFemale" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><strong><Currency :value="this.percentageOfAchievementFemaleTurnover" :unit="this.unit2"/></strong></span></td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfRegular" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfNonRegular" :unit="this.unit2"/></span></td>
              <td><span class="human-capitalt-data-table__text"><Currency :value="this.percentageOfCorpTurnover" :unit="this.unit2"/></span></td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table03-->

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="turnover.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(turnover.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="turnover.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の財務情報データ
    turnover: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    // 労働者数（男性）
    sumOfMaleEmployee() {
      if ( !(this.turnover.regularMaleEmployee!=null && this.turnover.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleEmployee).length * String(this.turnover.nonRegularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleEmployee) || isNaN(this.turnover.nonRegularMaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleEmployee) + Number(this.turnover.nonRegularMaleEmployee);
      }
    },
    // 労働者数（正社員・女性）
    sumOfFemaleEmployee() {
      if ( !(this.turnover.regularFemaleEmployee!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleEmployee).length * String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleEmployee) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularFemaleEmployee) + Number(this.turnover.nonRegularFemaleEmployee);
      }
    },
    // 労働者数（正社員）
    sumOfRegularEmployee() {
      if ( !(this.turnover.regularMaleEmployee!=null && this.turnover.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleEmployee).length * String(this.turnover.regularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleEmployee) || isNaN(this.turnover.regularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleEmployee) + Number(this.turnover.regularFemaleEmployee);
      }
    },
    // 労働者数（非正規）
    sumOfNonRegularEmployee() {
      if ( !(this.turnover.nonRegularMaleEmployee!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleEmployee).length * String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleEmployee) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        return Number(this.turnover.nonRegularMaleEmployee) + Number(this.turnover.nonRegularFemaleEmployee);
      }
    },
    // 労働者数
    sumOfAllEmployee() {
      if ( !(this.sumOfRegularEmployee!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularEmployee) + Number(this.sumOfNonRegularEmployee);
      }
    },
    // 離職者数（男性）
    sumOfMaleTurnover() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.nonRegularMaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.nonRegularMaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.nonRegularMaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleTurnover) + Number(this.turnover.nonRegularMaleTurnover);
      }
    },
    // 離職者数（女性）
    sumOfFemaleTurnover() {
      if ( !(this.turnover.regularFemaleTurnover!=null && this.turnover.nonRegularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleTurnover).length * String(this.turnover.nonRegularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleTurnover) || isNaN(this.turnover.nonRegularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularFemaleTurnover) + Number(this.turnover.nonRegularFemaleTurnover);
      }
    },
    // 離職者数（正社員）
    sumOfRegularTurnover() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.regularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.regularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.regularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.regularMaleTurnover) + Number(this.turnover.regularFemaleTurnover);
      }
    },
    // 離職者数（非正規）
    sumOfNonRegularTurnover() {
      if ( !(this.turnover.nonRegularMaleTurnover!=null && this.turnover.nonRegularFemaleTurnover!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleTurnover).length * String(this.turnover.nonRegularFemaleTurnover).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleTurnover) || isNaN(this.turnover.nonRegularFemaleTurnover)) {
        return null;
      }else{
        return Number(this.turnover.nonRegularMaleTurnover) + Number(this.turnover.nonRegularFemaleTurnover);
      }
    },
    // 離職者数（全社）
    sumOfAllTurnover() {
      if ( !(this.sumOfRegularTurnover!=null && this.sumOfNonRegularTurnover!=null) ) {
        return null;
      }else {
        return Number(this.sumOfRegularTurnover) + Number(this.sumOfNonRegularTurnover);
      }
    },
    // 離職率（正社員・男性）
      percentageOfRegularMale() {
      if ( !(this.turnover.regularMaleTurnover!=null && this.turnover.regularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularMaleTurnover).length * String(this.turnover.regularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.regularMaleTurnover) || isNaN(this.turnover.regularMaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.regularMaleTurnover == 0 ) return 0;
        if ( this.turnover.regularMaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.regularMaleTurnover) / Number(this.turnover.regularMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規・男性）
      percentageOfNonRegularMale() {
      if ( !(this.turnover.nonRegularMaleTurnover!=null && this.turnover.nonRegularMaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularMaleTurnover).length * String(this.turnover.nonRegularMaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularMaleTurnover) || isNaN(this.turnover.nonRegularMaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.nonRegularMaleTurnover == 0 ) return 0;
        if ( this.turnover.nonRegularMaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.nonRegularMaleTurnover) / Number(this.turnover.nonRegularMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（正社員・女性）
      percentageOfRegularFemale() {
      if ( !(this.turnover.regularFemaleTurnover!=null && this.turnover.regularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.regularFemaleTurnover).length * String(this.turnover.regularFemaleEmployee).length == 0) {
        return null;
      }else if ( isNaN(this.turnover.regularFemaleTurnover) || isNaN(this.turnover.regularFemaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.regularFemaleTurnover == 0 ) return 0;
        if ( this.turnover.regularFemaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.regularFemaleTurnover) / Number(this.turnover.regularFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規・女性）
      percentageOfNonRegularFemale() {
      if ( !(this.turnover.nonRegularFemaleTurnover!=null && this.turnover.nonRegularFemaleEmployee!=null) ) {
        return null;
      }else if ( String(this.turnover.nonRegularFemaleTurnover).length *  String(this.turnover.nonRegularFemaleEmployee).length == 0 ) {
        return null;
      }else if ( isNaN(this.turnover.nonRegularFemaleTurnover) || isNaN(this.turnover.nonRegularFemaleEmployee)) {
        return null;
      }else{
        if ( this.turnover.nonRegularFemaleTurnover == 0 ) return 0;
        if ( this.turnover.nonRegularFemaleEmployee == 0 ) return null;
        let val = (Number(this.turnover.nonRegularFemaleTurnover) / Number(this.turnover.nonRegularFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
      // 離職率（正社員）
    percentageOfRegular() {
      if ( !(this.sumOfRegularTurnover!=null && this.sumOfRegularEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfRegularTurnover == 0 ) return 0;
        if ( this.sumOfRegularEmployee == 0 ) return null;
        let val = (Number(this.sumOfRegularTurnover) / Number(this.sumOfRegularEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（非正規）
    percentageOfNonRegular() {
      if ( !(this.sumOfNonRegularTurnover!=null && this.sumOfNonRegularEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfNonRegularTurnover == 0 ) return 0;
        if ( this.sumOfNonRegularEmployee == 0 ) return null;
        let val = (Number(this.sumOfNonRegularTurnover) / Number(this.sumOfNonRegularEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（男性）
    percentageOfAchievementMaleTurnover() {
      if ( !(this.sumOfMaleTurnover!=null && this.sumOfMaleEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfMaleTurnover == 0 ) return 0;
        if ( this.sumOfMaleEmployee == 0 ) return null;
        let val = (Number(this.sumOfMaleTurnover) / Number(this.sumOfMaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（女性）
    percentageOfAchievementFemaleTurnover() {
      if ( !(this.sumOfFemaleTurnover!=null && this.sumOfFemaleEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfFemaleTurnover == 0 ) return 0;
        if ( this.sumOfFemaleEmployee == 0 ) return null;
        let val = (Number(this.sumOfFemaleTurnover) / Number(this.sumOfFemaleEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    // 離職率（全社）
    percentageOfCorpTurnover() {
      if ( !(this.sumOfAllTurnover!=null && this.sumOfAllEmployee!=null) ) {
        return null;
      }else {
        if ( this.sumOfAllTurnover == 0 ) return 0;
        if ( this.sumOfAllEmployee == 0 ) return null;
        let val = (Number(this.sumOfAllTurnover) / Number(this.sumOfAllEmployee) ) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
  },
  validations: {
    turnover: {
      regularMaleEmployee : { numeric, between: between(0,99999) },      // 労働者数（正社員・男性）
      regularFemaleEmployee : { numeric, between: between(0,99999) },    // 労働者数（正社員・女性）
      nonRegularMaleEmployee : { numeric, between: between(0,99999) },   // 労働者数（非正規・男性）
      nonRegularFemaleEmployee : { numeric, between: between(0,99999) }, // 労働者数（非正規・女性）
      regularMaleTurnover : { numeric, between: between(0,99999) },      // 離職者数（正社員・男性）
      regularFemaleTurnover : { numeric, between: between(0,99999) },    // 離職者数（非正規・男性）
      nonRegularMaleTurnover : { numeric, between: between(0,99999) },   // 離職者数（正社員・女性）
      nonRegularFemaleTurnover : { numeric, between: between(0,99999) }, // 離職者数（非正規・女性）

      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    turnover() {
      this.inputTurnover();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputTurnover() {
      this.$emit("change-turnover", {
        turnover: this.turnover,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
